import '@babel/polyfill'
import Vue from 'vue'

import '@/plugins/quasar'
import '@/plugins/http-client/index'

import App from '@/App.vue'
import router from '@/system/router'
import store from '@/system/store'

import '@/system/socket'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import i18n from '@/plugins/localisation'

import { GET_AUTH, GET_SELECTED_CUSTOMER, GET_USER } from '@/system/store/getter-types'
import { CONNECT_WS, CLOSE_WS } from '@/system/store/action-types'
import { QVueGlobals } from 'quasar'

const { VUE_APP_SENTRY_URL, VUE_APP_RELEASE, NODE_ENV, VUE_APP_LOCAL } = process.env

Vue.config.productionTip = false
Vue.config.devtools = true

if (!VUE_APP_LOCAL) {
  Sentry.init({
    dsn: VUE_APP_SENTRY_URL,
    integrations: [new Integrations.Vue({ Vue })],
    release: VUE_APP_RELEASE,
    environment: NODE_ENV
  })
}

declare module 'vue/types/vue' {
  interface Vue {
    $socket: any
    $connect: any
    $q: QVueGlobals
    $auth: any
  }
  interface VueConstructor {
    socket: any
  }
}

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
  async beforeCreate () {
    const { token } = this.$store.getters[GET_AUTH]
    const { isAgentUser } = this.$store.getters[GET_USER]
    const { id: customerId } = this.$store.getters[GET_SELECTED_CUSTOMER]
    if (!this.$socket && token && (customerId || isAgentUser)) {
      await this.$store.dispatch(CLOSE_WS)
      await this.$store.dispatch(CONNECT_WS)
    }
  }
}).$mount('#app')
